<script lang="ts">
    import MainLayout from "../../../#common/layout/Layout.svelte"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import {Link} from 'svelte-routing'
    import backIcon from 'src/components/cabinet/#assets/left-icon.svg'
    import Eggs from 'src/components/cabinet/inventory/components/category/Eggs.svelte'
    import Units from 'src/components/cabinet/inventory/components/category/Units.svelte'

    export let category

    if (!['eggs', 'units'].includes(category)) {
        location.href = '/inventory'
    }
</script>

<svelte:head>
    <title>{category.charAt(0).toUpperCase() + category.slice(1)}</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">
                <Link to="inventory" class="btn btn-second back"><img src={backIcon} alt=""> Back</Link>
                {category.charAt(0).toUpperCase() + category.slice(1)}
            </div>
            <Alert />
            {#if category === 'eggs'}
                <Eggs/>
            {:else if category === 'units'}
                <Units/>
            {/if}
        </div>
    </svelte:fragment>
</MainLayout>

<style>

</style>
